import { render, staticRenderFns } from "./CmgCreditCard.vue?vue&type=template&id=a283c640&scoped=true&lang=pug&"
import script from "./cmg-credit-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-credit-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCreditCard.vue?vue&type=style&index=0&id=a283c640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a283c640",
  null
  
)

export default component.exports